import type { SsoSessionJoined, SsoSessionStarted } from '@estimating/sso';
import { z } from 'zod';

// The single sign-on client in @estimating/sso, which ImEX Online and Rome Online copy,
// defines these shapes; each schema must satisfy the client's type (D-060).

/**
 * Response of `POST /v1/sso/session`: the caller's sign-in is now shared with the
 * brand's other apps. The cookies themselves come in `Set-Cookie`.
 */
export const SsoSessionStartedSchema = z.object({
  marker: z.string().min(1),
}) satisfies z.ZodType<SsoSessionStarted>;

/** Response of `POST /v1/sso/token`: what an app signs in with to join the shared sign-in. */
export const SsoSessionJoinedSchema = SsoSessionStartedSchema.extend({
  uid: z.string().min(1),
  customToken: z.string().min(1),
}) satisfies z.ZodType<SsoSessionJoined>;
